import { render, staticRenderFns } from "./ArrowMoveUpIcon.vue?vue&type=template&id=3f5bc06c"
import script from "./ArrowMoveUpIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowMoveUpIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports